import { render } from "./UserPosts.vue?vue&type=template&id=29874662"
import script from "./UserPosts.vue?vue&type=script&lang=js"
export * from "./UserPosts.vue?vue&type=script&lang=js"

import "./UserPosts.vue?vue&type=style&index=0&id=29874662&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__